<template>
  <div class="chart-block">
    <Bar
      v-if="block.chartType === 'bar'"
      :data="chartData"
      :options="chartOptions"
    />
    <Line
      v-else
      :data="chartData"
      :options="chartOptions"
    />
  </div>
</template>

<script>
import { Bar, Line } from 'vue-chartjs'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
} from 'chart.js'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement
)

export default {
  name: 'ChartBlock',
  components: {
    Bar,
    Line,
  },
  props: {
    /**
     * Chart block payload.
     *
     * Suggested shape:
     * - chartType: 'bar' | 'line'
     * - labels: string[]
     * - datasets: Chart.js compatible dataset array
     * - options?: Chart.js options object
     */
    block: {
      type: Object,
      required: true,
    },
  },
  computed: {
    chartData() {
      return {
        labels: this.block.labels || [],
        datasets: this.block.datasets || [],
      }
    },
    chartOptions() {
      return (
        this.block.options || {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: true,
            },
          },
        }
      )
    },
  },
}
</script>

<style scoped lang="scss">
.chart-block {
  height: 180px;
}
</style>

